module.exports = __webpack_public_path__ + "static/img/value03.d105879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/value03.png
// module id = npgC
// module chunks = 0